module.exports = __webpack_public_path__ + "static/media/example05-01.4ea64669.svg";